import React from 'react';
import {TileTypes} from './constants'
import './Tile.css'

export default function Tile(props:any) {
    const {
        tileType, 
        isLocked, 
        onClick,
        row,
        column
    } = props

    const cssClasses = [
        'tile',
        `${'tile-' + TileTypes[tileType].toLowerCase()}`,
        `${isLocked ? 'locked' : ''}`
    ]
    return (
        <td onClick={() => {onClick(props)}} className={cssClasses.join(' ')}></td>
    )
}